import React from 'react';

const NavOverlay = ({ onClick }) => <div className="sidebar-overlay" onClick={onClick} />;
export default NavOverlay;
